<nz-card (click)="emitCardClick(incident)" class="cursor-pointer">
  <div class="flex flex-col">
    <div class="flex items-center text-xs gap-x-2" *ngIf="incident?.display_name as display_name">
      <i nz-icon [nzType]="'hezky:Location'" nzTheme="outline"></i>
      <span class="font-normal" [title]="display_name">{{ display_name }}</span>
    </div>
    <div class="text-base font-semibold text-gray-600 truncate" [title]="incident?.asset_name">{{ incident?.asset_name }}</div>
  </div>

  <div class="flex items-center gap-x-2 mt-1 mb-2">
    <ng-container>
      <div class="flex items-center">
        <i class="text-3xl -ml-[5px] mt-1 mr-0.5" nz-icon [nzType]="'hezky:'+incident.incident_type" [ngClass]="feUtil.getSeverityColor(incident.severity)"></i>
        <div class="text-[2.2rem] leading-none font-normal" [ngClass]="feUtil.getSeverityColor(incident?.severity)">
          {{feUtil.getFormattedTemp(incident.current_alarm, incident.incident_type.toLowerCase())}}
        </div>
      </div>
    </ng-container>

    <!-- <ng-container [ngSwitch]="incident.incident_type">
      <ng-container *ngSwitchCase="'Humidity'">
        <div class="flex items-center">
          <i class="text-3xl -ml-[5px] mt-1 mr-1" nz-icon
            [nzType]="'hezky:humidity'"></i>
          <div class="text-4xl font-normal" [ngClass]="{
                    'text-danger': incident.severity === 'High',
                    'text-[#FF8D0F]': incident.severity === 'Medium',
                    'text-warning': incident.severity === 'Low'}">
            {{feUtil.getFormattedTemp(incident.current_alarm, incident.incident_type.toLowerCase())}}
          </div>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'Pressure'">
        <div class="flex items-center">
          <i class="text-[2.0rem] -ml-[5px] mt-0.5 mr-1" nz-icon
            [nzType]="'hezky:pressure'"></i>
          <div class="text-[2.2rem] leading-none font-normal" [ngClass]="{
                    'text-danger': incident.severity === 'High',
                    'text-[#FF8D0F]': incident.severity === 'Medium',
                    'text-warning': incident.severity === 'Low'}">
            {{feUtil.getFormattedTemp(incident.current_alarm, incident.incident_type.toLowerCase())}}
          </div>
        </div>
      </ng-container>
    </ng-container> -->

    <div class="text-xs" [ngClass]="feUtil.getSeverityColor(incident?.severity)">
      <div>
        {{incident?.threshold_condition}} {{ feUtil.getFormattedTemp(incident.threshold_value,
        incident.incident_type.toLowerCase()) }}
      </div>
      <div class="text-nowrap">
        Duration: {{ incident.triggered_time | relativeTime:"card" }}
      </div>
    </div>
  </div>

  <div class="text-gray-600 flex gap-x-2 text-xs font-semibold mt-3">
    <span>
      <i nz-icon nzType="calendar" nzTheme="outline"></i>
      {{ incident.triggered_time | gDate: "MMM d, y" }}
    </span>
    <span>
      <i nz-icon nzType="clock-circle" nzTheme="outline"></i>
      {{ incident.triggered_time | gDate: "HH:mm:ss" }}
    </span>
  </div>
</nz-card>